/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import useLocales from '@/hooks/useLocales';
import {LoadingButton} from '@mui/lab';

type DeletePopUpProps = {
  title?: string;
  subtext?: string;
  header?: string;
  confirmButtonText: string;
  loading?: boolean;
  open?: boolean;
  handleClose?: () => void;
  permissions?: any;
  handleConfirm: (e?: any) => void;
  classes?: any;
};

const DeletePopUp: React.FC<DeletePopUpProps> = ({
  title,
  subtext,
  loading,
  header,
  open,
  handleClose,
  permissions,
  handleConfirm,
  classes,
  confirmButtonText
}) => {
  const {translate} = useLocales();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`delete-error-pop ${classes}`}
    >
      <DialogTitle
        id="alert-dialog-title"
        className="bg-red text-white text-[28px] leading-8 font-medium font-lato"
      >
        {header}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          style={{position: 'absolute', right: 8, top: 8}}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="flex items-center">
        <DialogContentText id="alert-dialog-description">
          <span className="flex flex-col justify-center items-center">
            <span className="text-light-black mb-3 mt-[22px] text-[12px] leading-5 font-normal font-open-sans">
              {title}
            </span>
            <span className="text-gray-500 text-md font-normal">{subtext}</span>
            <span className="text-gray-500 text-md font-normal">
              {permissions}
            </span>
          </span>
        </DialogContentText>
      </DialogContent>
      <DialogActions className="p-[15px]">
        <LoadingButton
          loading={loading}
          onClick={handleClose}
          className="capitalize text-black text-[14px] font-medium secondary-button"
        >
          {translate('cancel')}
        </LoadingButton>
        <LoadingButton
          loading={loading}
          onClick={handleConfirm}
          className="bg-red capitalize text-white text-[14px] font-medium primary-button"
        >
          {confirmButtonText}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePopUp;
